import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Heading } from '@/components/ui/heading';
import { JOURNAL_STEP_ICONS } from './stepIcons';

export type WritingChoiceStepProps = {
  onSelectSolo: () => void;
  onStartCoach: () => void;
  onResumeDraft: () => void;
  isStartingCoach: boolean;
  coachError?: string | null;
};

export default function WritingChoiceStep({
  onSelectSolo,
  onStartCoach,
  isStartingCoach,
  coachError,
}: WritingChoiceStepProps) {
  const StepIcon = JOURNAL_STEP_ICONS.writingChoice;

  return (
    <Card>
      <CardHeader>
        <Heading
          level={2}
          icon={StepIcon}
          description="Puoi procedere da solo oppure chiedere l’aiuto del coach per costruire il racconto."
          wrapperClassName="mb-6"
        >
          Scegli come scrivere
        </Heading>
      </CardHeader>

      <CardContent>
        <div className="grid gap-4 md:grid-cols-2">
          <Card className="p-4 border-primary/30 bg-primary/5 space-y-3">
            <h3 className="font-semibold">Scrivo da solo</h3>
            <p className="text-sm text-muted-foreground">
              Passa direttamente alla tua bozza. Puoi sempre tornare indietro o attivare il coach
              più tardi.
            </p>
            <Button onClick={onSelectSolo}>Inizia a scrivere</Button>
          </Card>

          <Card className="p-4 space-y-3">
            <h3 className="font-semibold">Scriviamo insieme al coach</h3>
            <p className="text-sm text-muted-foreground">
              Il coach userà le informazioni raccolte per guidarti con domande mirate e aiutarti a
              formulare il testo.
            </p>
            <Button onClick={onStartCoach} disabled={isStartingCoach} variant="secondary">
              {isStartingCoach ? 'Avvio coach...' : 'Attiva il coach'}
            </Button>
            {coachError && <p className="text-sm text-destructive">{coachError}</p>}
          </Card>
        </div>
      </CardContent>
    </Card>
  );
}
